import { ModalMap } from "../modal/modalTypes";

type Props = ModalMap["confirm"] & {
  closeModal: () => void;
};

export function ConfirmModal({ title, message, onConfirm, closeModal }: Props) {
  return (
    <div>
      <h3>{title}</h3>
      <p>{message}</p>

      <button
        onClick={() => {
          onConfirm();
          closeModal();
        }}
      >
        Confirm
      </button>

      <button onClick={closeModal}>Cancel</button>
    </div>
  );
}
